import { gql } from "@apollo/client";

export const listSaddlesForAdmin = gql`
    query listSaddlesForAdmin($discipline: [String!], $brandName: String) {
      listSaddlesForAdmin(
        discipline: $discipline
        brandName: $brandName
      ) {
        count
        items {
          brandName
          createdAt
          description
          discount
          discipline
          gallery
          newOrUsed
          photo
          pk
          price
          productTitle
          quantity
          saddlefitSku
          scannedFiles
          score
          size
          sk
          status
          updatedAt
          type
          userId
          variantId
        }
      }
    }
  `;
